import React from 'react'
import CancelIcon from '@mui/icons-material/Cancel'
import makeStyles from '@mui/styles/makeStyles'

const useStyles = makeStyles(() => ({
  errorIcon: {
    fontSize: 48,
    color: 'white',
    marginBottom: '10px',
  },
  errorMessage: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    textAlign: 'center',
    color: 'white',
    fontSize: '18px',
    margin: '0 0 10px 0',
  },
  errorDescription: {
    fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
    textAlign: 'center',
    color: 'white',
    fontSize: '14px',
    margin: 0,
  },
  errorContainer: {
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(10, 104, 141, 0.8)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

interface ViewerErrorProps {
  message?: any
}

export function ViewerError({ message }: ViewerErrorProps): JSX.Element {
  const classes = useStyles()

  // Ensure message is always a string
  const displayMessage = message?.errorMessage ? message.errorMessage : message

  return (
    <div className={classes.errorContainer}>
      <CancelIcon className={classes.errorIcon} />
      <h3 className={classes.errorMessage}>{displayMessage}</h3>
    </div>
  )
}
